import { Box, Button, Grid, IconButton, InputAdornment, makeStyles, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getOrderInfo } from "../../actions/editOrderActions";
import { handleValidTnos, saveSearchTnos } from "../../actions/selfPickupActions";
import { handleOpenSelfPickupSection } from "../../reducers/uiSlice";
import FullscreenLoading from "../Common/FullscreenLoading";
import UniDialogPad from "../Common/UniDialogPad";
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import { userLogout } from "../../actions/userActions";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        "& .MuiOutlinedInput-multiline": {
            paddingRight: '40px !important'
        },
        "& .MuiTextField-root": {
            margin: theme.spacing(),
            width: 20
        },
        "& .MuiOutlinedInput-root": {
            position: "relative"
        },
        "& .MuiIconButton-root": {
            position: "absolute",
            top: 0,
            right: 0
        }
    },
    logout: {
        width: '100%',
        textAlign: 'right',
        paddingRight: 40,
        paddingTop: 10,
        color: theme.palette.warning.main,
        fontSize: 20
    },
    pageTitle: {
        fontSize: 28,
        color: '#FBFBFB',
        fontWeight: 600,
        marginTop: 70
    },
    pageContent: {
        fontSize: 18,
        color: '#FBFBFB',
        marginTop: 44,
        width: 600
    }
}))


function SearchIndex() {
    const { t } = useTranslation('selfPickup');
    const classes = useStyles();
    const dispatch = useDispatch();

    const savedSearchTnos = useSelector(state => state.selfPickupReducer.searchTnos || '');

    const [tnos, setTnos] = useState('');
    const [loading, setLoading] = useState(false);
    const [invalidTnos, setInvalidTnos] = useState([]);
    const [existValid, setExistValid] = useState(false);
    const [invalidOpen, setInvalidOpen] = useState({
        open: false,
        hideSubmit: false
    });

    const handleSearch = async () => {
        try {
            if (tnos) {
                setLoading(true);
                const tnosArr = tnos.replace(/\s/g, '').split(',');
                let validTnos = [];
                let invalidTnosArr = [];
                await Promise.all(tnosArr.map(async (tno) => {
                    if (tno) {
                        await dispatch(getOrderInfo(tno, 'tno'))
                            .then((validTno) => {
                                if (validTno.orders.latest_status === 213 || validTno.orders.latest_status === 214) {
                                    validTnos.push(validTno);
                                    setExistValid(true);
                                } else {
                                    invalidTnosArr.push(tno);
                                }
                            })
                            .catch(() => {
                                invalidTnosArr.push(tno);
                            })
                    }
                }))
                await dispatch(saveSearchTnos(tnos));
                await dispatch(handleValidTnos(validTnos));
                if (invalidTnosArr.length > 0) {
                    setInvalidTnos(invalidTnosArr);
                    if (validTnos.length === 0) {
                        setInvalidOpen({
                            open: true,
                            hideSubmit: true
                        });
                    } else {
                        setInvalidOpen({
                            open: true,
                            hideSubmit: false
                        });
                    }
                } else {
                    await handleNextPage();
                }
            }
        } catch (err) {
        } finally {
            setLoading(false);
        }
    }

    const handleNextPage = () => {
        dispatch(handleOpenSelfPickupSection(1));
    }

    const handleLogOut = () => {
        userLogout();
    }

    useEffect(() => {
        setTnos(savedSearchTnos)
    }, [savedSearchTnos])

    useEffect(() => {
        setExistValid(false);
    }, [])

    return (
        <Box className={classes.root}>
            <div className={classes.logout} onClick={handleLogOut}>
                {t('common:log_out')}
            </div>
            <div className={classes.pageTitle}>
                {t('customer_pickup')}
            </div>
            <div className={classes.pageContent}>
                {t('tno_info')}
            </div>
            <TextField
                label={t('tracking_numbers')}
                style={{ width: 600, marginTop: 25 }}
                multiline
                rows={6}
                variant="outlined"
                value={tnos}
                onChange={(e) => setTnos(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <IconButton>
                            <CancelRoundedIcon onClick={() => setTnos('')} />
                        </IconButton>
                    )
                }}
            />
            <Button
                color='primary'
                variant='contained'
                onClick={handleSearch}
                style={{ width: 311, marginTop: 24 }}
            >
                {t('search')}
            </Button>
            <div
                className={classes.photoGroup}
                style={{
                    height: 60,
                    width: 208,
                    marginTop: 180,
                    backgroundImage: "url('./images/selfPickupLogo.png')",
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }}
            ></div>
            <UniDialogPad
                open={invalidOpen.open}
                autoClose={false}
                onClose={() => {
                    setInvalidOpen((prev) => ({
                        ...prev,
                        ['open']: false
                    }))
                }}
                onFinish={() => {
                    if (existValid) {
                        handleNextPage();
                    } else {
                        setInvalidOpen((prev) => ({
                            ...prev,
                            ['open']: false
                        }))
                    }
                }}
                title={t('error')}
                cancelButtonText={t('cancel')}
                finishButtonText={t('ignore_proceed')}
                maxwidth='sm'
                fullWidth
                hideSubmit={invalidOpen.hideSubmit}
            >
                {
                    invalidTnos.map((invalidTno) => (
                        <div style={{ marginBottom: 10 }}>{invalidTno}</div>
                    ))
                }
                <div>{t('invalid_tnos')}</div>
            </UniDialogPad>
            <FullscreenLoading open={loading} />
        </Box>
    )
}

export default SearchIndex;